<influencer-module-container 
	[title]="'INFLUENCER.insight.best_performing_posts.title' | translate"
	[hasNoData]="hasNoData || isFetchingData"
	[isFetchingData]="isFetchingData" 
	[placeholderWidth]="361"
	[printMode]="printMode">

	<div class="latest-posts-table" [class.print-mode]="printMode" *ngIf="!hasNoData && !isFetchingData">
		<div class="row">
			<div class="col-sm-12">
				<div class="table-header">
					<div class="header-col index">
						<span class="cell">#</span>
					</div>
	
					<div class="header-col">
					</div>
	
					<div class="header-col">
						<span class="cell">{{'INFLUENCER.insight.best_performing_posts.influencer_post' | translate}}</span>
					</div>
	
					<div class="header-col">
						<span class="cell">{{'INFLUENCER.insight.best_performing_posts.reach' | translate}}</span>
					</div>
	
					<div class="header-col">
						<span class="cell">{{'INFLUENCER.insight.best_performing_posts.interaction' | translate}}</span>
					</div>
	
					<div class="header-col">
						<span class="cell">{{'INFLUENCER.insight.best_performing_posts.impact' | translate}}</span>
					</div>
				</div>
			</div>
		</div>
	
		<div class="row">
			<div class="col-sm-12" *ngFor="let post of bestPerformingPosts; let i = index; let lastRow = last">
				<best-performing-post-item [post]="post" [index]="i" [isLastItem]="lastRow" [printMode]="printMode"></best-performing-post-item>
			</div>
		</div>
	</div>

	<best-performing-posts-placeholder *ngIf="hasNoData || isFetchingData" [printMode]="printMode"></best-performing-posts-placeholder>
</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-posts/best-performing-posts.component.html